
import $ from "jquery";
import React, { Component, createRef, Fragment } from "react";
import { Button } from '@material-ui/core';
import Swal from 'sweetalert2'

window.jQuery = $;
window.$ = $;

require("jquery-ui-sortable");
require("formBuilder");
require('formBuilder/dist/form-render.min.js')
require('formBuilder/dist/form-builder.min.js')



// const options = {
//     defaultFields: [{
//         "type": "header",
//         "subtype": "h1",
//         "label": "Header"
//     },
//     {
//         "type": "text",
//         "label": "Subject",
//         "className": "form-control",
//         "name": "text-1568543650327",
//         "subtype": "text"
//     },
//     {
//         "type": "textarea",
//         "label": "Message",
//         "className": "form-control",
//         "name": "textarea-1568543651609",
//         "subtype": "textarea",
//         "rows": 4
//     }],
//     disabledActionButtons: ['data', 'save'],
//     disableFields: ['button', 'file', 'hidden'],
//     disabledAttrs: ['name', 'className', 'required', 'access', 'value', 'step'],
//     typeUserDisabledAttrs: {
//         'textarea': [
//             'subtype'
//         ],
//         'text': [
//             'subtype'
//         ],
//         'paragraph': [
//             'subtype'
//         ],
//     },
//     stickyControls: {
//         enable: true
//     },
// }




class FormBuilderJQStart extends Component {

    componentDidMount() {

        const { handleNext, formJq } = this.props;
        let deff = [{
            "type": "header",
            "subtype": "h1",
            "label": "Header"
        },
        {
            "type": "text",
            "label": "Subject",
            "className": "form-control",
            "name": "text-1568543650327",
            "subtype": "text"
        },
        {
            "type": "textarea",
            "label": "Message",
            "className": "form-control",
            "name": "textarea-1568543651609",
            "subtype": "textarea",
            "rows": 4
        }]
        if (formJq) {
            deff = formJq;
        }

        let options = {
            defaultFields: deff,
            disabledActionButtons: ['data', 'save'],
            disableFields: ['button', 'file', 'hidden'],
            disabledAttrs: ['name', 'className', 'required', 'access', 'value', 'step','other'],
            typeUserDisabledAttrs: {
                'textarea': [
                    'subtype'
                ],
                'text': [
                    'subtype'
                ],
                'paragraph': [
                    'subtype'
                ],
            },
            stickyControls: {
                enable: true
            },
        }

        var fbEditor = document.getElementById('fb-editor');
        var formBuilder = $(fbEditor).formBuilder(options);


        // document.getElementById('getJSON').addEventListener('click', function () {
        //     console.log(formBuilder.actions.getData('json', true));
        // });

        document.getElementById('next').addEventListener('click', function () {
            // const data = formBuilder.actions.getData('json', true)
            for (let index = 0; index < document.getElementsByClassName('option-value').length; index++) {
                document.getElementsByClassName('option-value')[index].value = document.getElementsByClassName('option-label')[index].value
            }
            const data = formBuilder.actions.getData()
            let flag = false;
            let list = ['text', 'number', 'autocomplete','checkbox-group','number','textarea','select','radio-group','date'];
            for (let index = 0; index < data.length; index++) {
                let element = data[index];
                 if (list.includes(element.type))
                {
                    flag = true;
                    break;
                }
            }
            if (flag === true) {
                handleNext(data)
            } else {
                Swal.fire({
                    text: 'Oops! Looks like you forgot to add an input field for your form'
                })
            }
        });
    }


    render() {
        const { handleBack } = this.props
        return (
            <Fragment>
                <div className="builderjq-wrapper">
                    <div className="jq-form">
                        <form id="fb-editor"></form>
                    </div>
                    <div className="jqBuilder-button-container" >
                        <Button
                            onClick={handleBack}
                            variant="outlined"
                            color='primary'
                        >Back</Button>
                        <Button
                            id="next"
                            variant="contained"
                            color='primary'
                        >next</Button>
                    </div>

                </div>

                {/* <div>
                <button id="getJSON">Get Json Data</button>
                <button id="next">Next</button>
                </div> */}
            </Fragment>
        )
    }
}

export default FormBuilderJQStart;



// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/FormBuilderJQStart.js